module.exports = __webpack_public_path__ + "static/media/clap01.3019756d.mp3";